import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { MessagesSquare, Zap } from "lucide-react";

/**
 * Shared create-automation items — used by the rail-head create glyph. The
 * heading ("Create") carries the verb, so each row is just the noun, matching
 * the workspaces glyph register.
 */
export const automationsCreateMenuItems = (
  openCreatePane: () => void,
  createWithAgent: () => void,
) => (
  <>
    <DropdownMenuItem
      onSelect={() => window.setTimeout(() => openCreatePane(), 0)}
    >
      <Zap className="size-3.5 text-n-50" />
      Automation
    </DropdownMenuItem>
    <DropdownMenuItem
      onSelect={() => window.setTimeout(() => createWithAgent(), 0)}
    >
      <MessagesSquare className="size-3.5 text-n-50" />
      With Agent
    </DropdownMenuItem>
  </>
);
